import { FormControl } from '@angular/forms';
import { GrocyBasics } from '../../../../core/entities/grocy/shared/basics.entity';
import { GrocyStockEntry } from '../../../../core/entities/grocy/stock-entries/stock-entry.entity';
import { positiveNotNull, requiredNotNull } from '../../../../forms/form-control-options.constants';
import { BaseFormControls } from '../../../../forms/form-controls/base.form-controls';

export abstract class GrocyDashboardQuickActionFormControls extends BaseFormControls {
  amount = new FormControl(1, positiveNotNull);
  stockEntry = new FormControl<GrocyStockEntry | null>(null);
}

export class GrocyDashboardQuickActionConsumeFormControls extends GrocyDashboardQuickActionFormControls {
  spoiled = new FormControl(false, requiredNotNull);
}

export class GrocyDashboardQuickActionOpenFormControls extends GrocyDashboardQuickActionFormControls {}

export class GrocyDashboardQuickActionTransferFormControls extends GrocyDashboardQuickActionFormControls {
  override stockEntry = new FormControl<GrocyStockEntry | null>(null, requiredNotNull);
  fromLocation = new FormControl<GrocyBasics | null>(null, requiredNotNull);
  toLocation = new FormControl<GrocyBasics | null>(null, requiredNotNull);
}
